import { api } from '@/main';

export const getRamos = ({ commit }) => {
  api('tablas/ramos').then(res => {
    commit('setRamos', res.data.ramos);
  });
};

export const getProductores = async (context, nroOrganizador) => {
  let productores;

  if (nroOrganizador) {
    //console.log('producers/' + nroOrganizador);
    await api('producers/' + nroOrganizador).then(res => {
      productores = res.data.producers;
      //console.log(productores);
    });
  } else {
    await api('producers').then(res => {
      productores = res.data.producers;
    });
  }
  context.commit('setProductores', productores);
};

export const getProductoresComisionesRetenciones = async (context) => {
  let productores;
  await api('comisiones-retenciones').then(res => {
    productores = res.data.producers;
  });
  context.commit('setProductoresComisionesRetenciones', productores);
};

export const getOrganizadores = async (context, ejecutivo) => {
  let organizadores;
    await api('organizers'+(ejecutivo?'/'+ejecutivo:'')).then(res => {
      organizadores = res.data.organizers;
    });
  context.commit('setOrganizadores', organizadores);
};

export const getTiposDeEndoso = async (context) => {
  let tiposDeEndoso;
  await api('tiposendoso').then(res => {
    tiposDeEndoso = res.data.tiposDeEndoso;
    //console.log(tiposDeEndoso);
  });
  context.commit('setTiposDeEndoso', tiposDeEndoso);
};

export const getAsegurados = ({ commit }, payload) => {
  api(`polizas/asegurados/${payload.poliza}/${payload.endoso}`).then(res => {
    commit(
      'setAseguradosOptions',
      res.data.map(item => ({
        text: item.cod_aseg + ' - ' + item.nombre,
        value: item.cod_aseg
      }))
    );
    //console.log('Listado de asegurados actualizado');
  });
};

export const getMonedas = ({ commit }, data) => {
  api('tablas/monedas').then(res => {
    commit('setMonedas', res.data.map(item => item.txt_desc));
  });
};

export const getTiposCuenta = ({ commit }) => {
  api('tablas/tipos-cuenta').then(res => {
    commit('setTiposCuenta', res.data.map(item => item.txt_nombre));
  });
};

/** Dashboard */
// vencimientos
export const fetchVencimientos = ({ state, commit }) => {
  return api
    .post('dashboard/vencimientos', state.filterVencimientos)
    .then(res => {
      commit('setVencimientos', res.data);
    })
    .catch(e => {
      commit('setVencimientos', 'X');
    });
};

// adeudadas
export const fetchAdeudadas = ({ state, commit }) => {
  return api
    .post('dashboard/adeudadas', state.filterAdeudadas)
    .then(res => {
      commit('setAdeudadas', res.data);
    })
    .catch(e => {
      commit('setAdeudadas', 'X');
    });
};

// refacturaciones rc
export const fetchRefacturacionesRc = ({ state, commit }) => {
  return api
    .post('dashboard/refacturaciones-rc', state.filterRefacturacionesRc)
    .then(res => {
      commit('setRefacturacionesRc', res.data);
    })
    .catch(e => {
      commit('setRefacturacionesRc', 'X');
    });
};

// refacturaciones rc - comentar si crashea en locals

export const fetchRefacturacionesPer = ({ state, commit }) => {
  /*return api.post('dashboard/refacturaciones-per', state.filterRefacturacionesPer).then(res => {
    commit('setRefacturacionesPer', res.data);
  }).catch(e => {
    commit('setRefacturacionesPer', 'X');
  });*/
};

export const fetchCategoriasRecursos = ({ commit }) => {
  return api.get('recursos/categoria').then(response => {
    commit('setCategoriasRecursos', response.data);
  });
};

export const fetchPostsRecursos = ({ commit }, id_categoria) => {
  return api('recursos/por-categoria/' + id_categoria).then(res => {
    commit('setPostsRecursos', res.data);
  });
};

export const addMenuProductor = ({ commit }, item) => {
  
    return commit('setMenuProductor', item);
};
